
export default function WhyCalledDangerous() {
  const reasons = [
    {
      icon: 'ri-funds-line',
      title: 'レバレッジで大きな損失が出る可能性',
      description:
        'FXでは最大25倍のレバレッジをかけられるため、少額の資金で大きな取引ができます。利益も大きくなりますが、同時に損失も拡大するリスクがあります。これがFXが「危険」と言われる最大の理由です。',
      point: 'ただし、レバレッジは自分でコントロールできます。',
    },
    {
      icon: 'ri-exchange-line',
      title: '為替変動による元本割れリスク',
      description:
        '為替レートは常に変動しており、予想と反対方向に動けば損失が発生します。FXは元本保証の商品ではないため、投資した金額を下回る可能性があります。',
      point: 'これは株式投資など他の投資商品にも共通するリスクです。',
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'ロスカット（強制決済）の存在',
      description:
        '含み損が一定水準を超えると、さらなる損失拡大を防ぐために強制的にポジションが決済されます。急激な相場変動時には、想定以上の損失が出ることもあります。',
      point: 'ロスカットは資産を守るための安全装置でもあります。',
    },
    {
      icon: 'ri-global-line',
      title: '海外の無登録業者との混同',
      description:
        'インターネット上には金融庁に無登録の海外FX業者も存在し、出金トラブルなどの被害報告があります。これらの悪質業者のイメージが「FX＝危険」という印象につながっています。',
      point: 'DMM FXは金融庁登録済みの国内正規業者です。',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-amber-100 rounded-lg mb-4">
            <i className="ri-error-warning-line text-2xl text-amber-600"></i>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            なぜ「危険」と言われるのか？
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            まずは「FXは危険」と言われる理由を正しく理解しましょう。原因を知れば、適切な対策が取れます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="bg-white rounded-xl p-6 shadow-md border border-gray-100 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-start mb-4">
                <div className="w-10 h-10 bg-amber-50 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${reason.icon} text-xl text-amber-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 pt-1">
                  {reason.title}
                </h3>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                {reason.description}
              </p>
              <div className="bg-teal-50 rounded-lg px-4 py-3 flex items-start">
                <i className="ri-lightbulb-line text-teal-600 mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                <p className="text-sm text-teal-700 font-medium">{reason.point}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 max-w-3xl mx-auto bg-amber-50 border border-amber-200 rounded-xl p-6">
          <div className="flex items-start">
            <i className="ri-information-line text-amber-600 text-xl mr-3 mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
            <div>
              <p className="text-sm text-amber-800 font-semibold mb-1">
                つまり…
              </p>
              <p className="text-sm text-amber-700 leading-relaxed">
                「危険」と言われる理由の多くは
                <strong>FXという投資商品そのもののリスク</strong>
                であり、DMM FXという会社が危険なわけではありません。リスクを正しく理解し、適切な資金管理を行えば、安全に取引を始めることができます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
